import modelBase from "../model-base.model";

var workTypeModel = {

  getWorkTypeList: function (successCallBack, failureCallBack) {
    // api/codemaster/worktype
    modelBase.get(successCallBack, failureCallBack, `/api/codemaster/worktype`);
  },

  getWorkTypeColorList: function (successCallBack, failureCallBack) {
    // api/codemaster/worktypecolor
    modelBase.get(successCallBack, failureCallBack, `/api/codemaster/worktypecolor`);
  },

}

export default workTypeModel;
